<template>
    <div>
        <CFTitle title="2. Atribute proiect"></CFTitle>
        <b-table striped hover :fields="fields" :items="items" thead-class="blue-head">
            <template v-slot:cell(atribute)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(yes)="data">
                <b-form-radio v-model="data.item.choice" :name="'some-radios-'+data.index" :value="true" :disabled="completed || !data.item.can_be_edited" @change="warnChange()"></b-form-radio>
            </template>
            <template v-slot:cell(no)="data">
                <b-form-radio v-model="data.item.choice" :name="'some-radios-'+data.index" :value="false" :disabled="completed || !data.item.can_be_edited" @change="warnChange()"></b-form-radio>
            </template>
        </b-table>

        <hr class="mt-5">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormRadio, BTable, BFormCheckbox} from "bootstrap-vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'

    export default {
        components: {
            CFTitle,
            BFormRadio,
            BTable,
            BFormCheckbox
        },
        props: {
            m3GrantApplication: null
        },
        data() {
            return {
                completed: false,
                fields: [
                    {
                        key: 'atribute',
                        label: 'Atribut',
                    },
                    {
                        key: 'yes',
                        label: 'Da',
                    },
                    {
                        key: 'no',
                        label: 'Nu',
                    }
                ],
                items: [
                    { atribute: 'Proiect major', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul figurează în lista Proiectelor Majore (PM)', choice: false, can_be_edited: true },
                    { atribute: 'Proiect fazat', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul face parte dintr-o rețea transeuropeană', choice: false, can_be_edited: true },
                    { atribute: 'Operațiunea este Plan de Acțiune Comun (PAC)', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul include finanțarea Inițiativa Locuri de Muncă pentru Tineri (ILMT)', choice: false, can_be_edited: true },
                    { atribute: 'Sprijinul public va constitui ajutor de stat', choice: true, can_be_edited: false },
                    { atribute: 'Proiectul este derulat în cadrul unei structuri Parteneriat Public Privat (PPP)', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul este generator de venit', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul este asociat cu site-ul Natura2000', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul este relevant pentru mecanismul ITI Delta Dunării', choice: false, can_be_edited: true },
                    { atribute: 'Proiectul este relevant pentru SUERD', choice: false, can_be_edited: true },
                ]
            }
        },
        computed: {
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Atribute proiect')) {
                        this.completed = true
                    }
                }
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.atribute_proiect && this.m3GrantApplication.atribute_proiect.length > 0){
                        this.items = this.m3GrantApplication.atribute_proiect
                    }
                },
                deep: true
            }
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.atribute_proiect && this.m3GrantApplication.atribute_proiect.length > 0){
                this.items = this.m3GrantApplication.atribute_proiect
            }
            if(this.finantareProgress && this.finantareProgress.includes('Atribute proiect')) {
                this.completed = true
            }
        },
        methods: {
            sendForm(){
                if(this.completed){
                    axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {atribute_proiect: this.items})
                        .then( () => {
                            this.$toast.success('Informațiile au fost salvate!')
                            this.$emit('savedData')
                            this.$store.dispatch('finantare/addToProgress', 'Atribute proiect')
                        })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Atribute proiect')
                }
            },
            warnChange() {
                this.$toast.error('Îți recomandăm să nu modifici aceste răspunsuri')
            }
        }
    }
</script>

<style scoped>
.small-item-table{
    font-size: 13px;
}
</style>
